import React from 'react';
import baseTheme from '../theme/index';
/**
 * This is all to deal with code splitting and css
 * import order. This component should be included
 * as early as possible so that the base theme is
 * included in the main css bundle.
 *
 * This is included in DaApp so you should not need it.
 */ const InnerNoop = ()=>{
    return null;
};
const BaseTheme = ()=>{
    return /*#__PURE__*/ React.createElement(InnerNoop, {
        theme: baseTheme
    });
};
BaseTheme.displayName = 'BaseEditorTheme';
export default BaseTheme;
